import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  GLOBAL_STATE,
  TEACHING_WORKLOAD_APPROVAL_ALL,
  TEACHING_WORKLOAD_APPROVAL_BY_ID,
  TEACHING_WORKLOAD_APPROVAL_RESPONSE,
  TEACHING_WORKLOAD_APPROVAL_SUBMIT,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const TEACHING_WORKLOAD = GLOBAL_STATE

const teachingWorkloadSlice = createSlice({
  name: TEACHING_WORKLOAD,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.teachingWorkloadApprovalAll.pending, state => {
        state[TEACHING_WORKLOAD_APPROVAL_ALL].loading = true
      })
      .addCase(actionCreators.teachingWorkloadApprovalAll.rejected, (state, action) => {
        state[TEACHING_WORKLOAD_APPROVAL_ALL].loading = false
        state[TEACHING_WORKLOAD_APPROVAL_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.teachingWorkloadApprovalAll.fulfilled, (state, action) => {
        state[TEACHING_WORKLOAD_APPROVAL_ALL].loading = false
        state[TEACHING_WORKLOAD_APPROVAL_ALL].error = null
        state[TEACHING_WORKLOAD_APPROVAL_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.teachingWorkloadApprovalByID.pending, state => {
        state[TEACHING_WORKLOAD_APPROVAL_BY_ID].loading = true
      })
      .addCase(actionCreators.teachingWorkloadApprovalByID.rejected, (state, action) => {
        state[TEACHING_WORKLOAD_APPROVAL_BY_ID].loading = false
        state[TEACHING_WORKLOAD_APPROVAL_BY_ID].error = action.payload as AxiosError
      })
      .addCase(actionCreators.teachingWorkloadApprovalByID.fulfilled, (state, action) => {
        state[TEACHING_WORKLOAD_APPROVAL_BY_ID].loading = false
        state[TEACHING_WORKLOAD_APPROVAL_BY_ID].error = null
        state[TEACHING_WORKLOAD_APPROVAL_BY_ID].data = action.payload
      })

    builder
      .addCase(actionCreators.teachingWorkloadApprovalSubmit.pending, state => {
        state[TEACHING_WORKLOAD_APPROVAL_SUBMIT].loading = true
      })
      .addCase(actionCreators.teachingWorkloadApprovalSubmit.rejected, (state, action) => {
        state[TEACHING_WORKLOAD_APPROVAL_SUBMIT].loading = false
        state[TEACHING_WORKLOAD_APPROVAL_SUBMIT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.teachingWorkloadApprovalSubmit.fulfilled, (state, action) => {
        state[TEACHING_WORKLOAD_APPROVAL_SUBMIT].loading = false
        state[TEACHING_WORKLOAD_APPROVAL_SUBMIT].error = null
        state[TEACHING_WORKLOAD_APPROVAL_SUBMIT].data = action.payload
      })

    builder
      .addCase(actionCreators.teachingWorkloadApprovalResponse.pending, state => {
        state[TEACHING_WORKLOAD_APPROVAL_RESPONSE].loading = true
      })
      .addCase(actionCreators.teachingWorkloadApprovalResponse.rejected, (state, action) => {
        state[TEACHING_WORKLOAD_APPROVAL_RESPONSE].loading = false
        state[TEACHING_WORKLOAD_APPROVAL_RESPONSE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.teachingWorkloadApprovalResponse.fulfilled, (state, action) => {
        state[TEACHING_WORKLOAD_APPROVAL_RESPONSE].loading = false
        state[TEACHING_WORKLOAD_APPROVAL_RESPONSE].error = null
        state[TEACHING_WORKLOAD_APPROVAL_RESPONSE].data = action.payload
      })

    builder.addCase(actionCreators.teachingWorkloadApprovalAllClear, state => {
      state[TEACHING_WORKLOAD_APPROVAL_ALL] = defaultState()
    })

    builder.addCase(actionCreators.teachingWorkloadApprovalByIDClear, state => {
      state[TEACHING_WORKLOAD_APPROVAL_BY_ID] = defaultState()
    })
  },
})

export const { reducer: teachingWorkloadReducer } = teachingWorkloadSlice
